import { faUser } from '@fortawesome/free-regular-svg-icons'
import React, { useState } from 'react'

import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import FooterBackButton from '@/components/FooterBackButton'
import H2 from '@/components/H2'
import IconButton from '@/components/IconButton'
import LoadBotLink from '@/components/LoadBotLink'
import type { ReferenceTier } from '@/lib/apollo/query/get-applicant'

interface Props {
  applicationId: string
  customerId: string
  subjectId: string
  referenceTier?: ReferenceTier | null
  isReferee?: boolean
}

const BotAccess = ({
  applicationId,
  customerId,
  subjectId,
  referenceTier,
  isReferee,
}: Props) => {
  const [botAccessSidebarOpen, setBotAccessSidebarOpen] = useState(false)

  return (
    <>
      {botAccessSidebarOpen && (
        <SlideInSidebar
          onClose={() => setBotAccessSidebarOpen(false)}
          header={<H2>View the chat bot for this applicant</H2>}
          content={
            <LoadBotLink
              subjectId={subjectId}
              applicationId={applicationId}
              customerId={customerId}
              applicantTier={referenceTier}
              isReferee={isReferee}
            />
          }
          footer={<FooterBackButton onClick={() => setBotAccessSidebarOpen(false)} />}
        />
      )}
      <IconButton
        tooltipMessage="View chat bot"
        icon={faUser}
        onClick={() => setBotAccessSidebarOpen(true)}
      />
    </>
  )
}

export default BotAccess
